import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Environment } from 'dashboard/models/environment';
import { Event } from 'dashboard/models/event';
import { WebhookEvent } from 'dashboard/models/webhook-event';
import {
  clearEvent,
  setEvent,
  setWebhookEvents,
  WebhookEventsFilterParams,
} from 'dashboard/redux/actions/event';
import { ApiEndpoint, PaginationParams } from 'lib/interfaces/api';

export function loadEvent(id: string) {
  return async (dispatch: Dispatch) => {
    dispatch(clearEvent());
    const eventResponse = await SessionClientDashboard.getResource<Event>(ApiEndpoint.Event, id);

    const event = eventResponse.data;

    dispatch(setEvent(event));
  };
}

export function loadWebhookEventList({
  currentEnvironment,
  currentPage,
  pageSize,
  filters,
}: {
  currentEnvironment: Environment;
  currentPage: number;
  pageSize: number;
  filters: WebhookEventsFilterParams;
}) {
  return async (dispatch: Dispatch) => {
    const paramsFull = {
      ...createParamsForList(currentEnvironment, filters),
      page: {
        number: currentPage,
        size: pageSize,
      },
    };

    const { data: webhookEvents, meta: paginationParams } =
      await SessionClientDashboard.listResource<WebhookEvent, PaginationParams>(
        ApiEndpoint.WebhookEvent,
        paramsFull,
      );

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    dispatch(setWebhookEvents(webhookEvents, paginationParams));
  };
}

function createParamsForList(currentEnvironment: Environment, filters: WebhookEventsFilterParams) {
  const { eventId, webhookId, status, updatedAtStart, updatedAtEnd, omni } = filters;

  return {
    filter: {
      'environment-id': currentEnvironment.id,
      status,
      'event-id': eventId,
      'webhook-id': webhookId,
      omni,
      'updated-at-start': updatedAtStart && updatedAtStart.toString(),
      'updated-at-end': updatedAtEnd && updatedAtEnd.toString(),
    },
  };
}
